import type { Vuetify2Theme } from '@gms/vuetify2-themes';
import { defineStore } from 'pinia';
import { ref, watchEffect } from 'vue';
import { useConfigStore } from './config';


export const useThemeStore = defineStore('theme', () => {
  const configStore = useConfigStore();
  const lsTheme = localStorage.getItem('theme');
  const theme = ref<Vuetify2Theme>(lsTheme ? JSON.parse(lsTheme) : undefined);
  watchEffect(() => {
    localStorage.setItem('theme', JSON.stringify(theme.value))
    if (configStore.config) {
      configStore.config.theme = theme.value
    }
  })
  const dark = ref(false)

  return { theme, dark }
});
